// Static reference lists for standouts feature
// (form dropdowns, filter options, status pills)

export const SPORTS = [
  'Flag Football',
  'Football',
  'Basketball',
  'Soccer',
  'Baseball',
  'Softball',
  'Volleyball',
  'Track & Field',
  'Wrestling',
  'Boxing',
  'Martial Arts',
  'Tennis',
  'Golf',
  'Swimming',
  'Cheer / Dance',
  'Other',
];

export const AWARDS = [
  'MVP',
  'Game Ball',
  'Most Improved',
  'Breakout Performance',
  'Top Offensive',
  'Top Defensive',
  'Leadership',
  'Effort',
  'Sportsmanship',
];

// Per client doc: Division = gender grouping
export const DIVISIONS = ['Boys', 'Girls', 'Coed'];

// Per client doc: Levels are grouped into 3 categories
export const LEVELS_GRADE = [
  'Kinder / 1st Grade',
  '1st / 2nd Grade',
  '3rd / 4th Grade',
  '5th / 6th Grade',
  '7th / 8th Grade',
];

export const LEVELS_AGE = ['6U', '8U', '10U', '12U', '14U', '16U', '18U'];

export const LEVELS_SCHOOL = ['Freshman', 'JV', 'Varsity'];

export const ALL_LEVELS = [...LEVELS_GRADE, ...LEVELS_AGE, ...LEVELS_SCHOOL];

export const STATUSES = ['pending', 'approved', 'published', 'rejected'];

export const STATUS_LABELS = {
  pending: 'Pending',
  approved: 'Approved',
  published: 'Published',
  rejected: 'Rejected',
};

export const SEASONS = ['Spring', 'Summer', 'Fall', 'Winter'];

export const GENDERS = ['Boys & Girls', 'Boys', 'Girls'];

// Award icon mapping (used in card rendering)
export const AWARD_ICONS = {
  'MVP': '/assets/images/award-mvp.png',
  'Game Ball': '/assets/images/award-game-ball.png',
  'Most Improved': '/assets/images/award-top-performer.png',
  'Breakout Performance': '/assets/images/award-top-performer.png',
  'Top Offensive': '/assets/images/award-top-offensive.png',
  'Top Defensive': '/assets/images/award-top-defensive.png',
  'Leadership': '/assets/images/award-top-performer.png',
  'Effort': '/assets/images/award-top-performer.png',
  'Sportsmanship': '/assets/images/award-top-performer.png',
};

const GAME_BALL_SPORT_EMOJI = {
  'Football': '🏈',
  'Flag Football': '🏈',
  'Basketball': '🏀',
  'Baseball': '⚾',
  'Softball': '🥎',
  'Volleyball': '🏐',
  'Soccer': '⚽',
  'Tennis': '🎾',
};

export const getAwardEmoji = (award, sport) => {
  if (award === 'MVP') return '🏆';
  if (award === 'Game Ball') return GAME_BALL_SPORT_EMOJI[sport] || '🏅';
  if (award === 'Most Improved') return '📈';
  if (award === 'Breakout Performance') return '⭐';
  if (award === 'Top Offensive') return '⚡';
  if (award === 'Top Defensive') return '🛡️';
  if (award === 'Leadership') return '👑';
  if (award === 'Effort') return '💪';
  if (award === 'Sportsmanship') return '🤝';
  return '🏅';
};

// Generate a URL-friendly slug from an org name
export const slugify = (str) => {
  if (!str) return '';
  return String(str)
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
};
